module.exports = __webpack_public_path__ + "img/sean-edwards-entourage.957878f.jpg";